import React from 'react';
import useIsMobileView from "../hooks/useIsMobileView";
import { Main, MainContent, Section, TopNavBar, Footer } from '@prosolve/common-components-ui'
import useFetch from '../hooks/useFetch';
import ImplementationCalendarPage from './ImplementationCalendarPage';
import './ImplementationCalendar.css'

const SectionDivider = () => <div style={{ height: '10px' }}>&nbsp;</div>

export default ({ isPrivate }) => {
  const fetch = useFetch();

  const isMobileView = useIsMobileView();
  
  return (
    <>
    { isPrivate && <TopNavBar fetch={fetch} />}
    <Main 
      $isMobileView={isMobileView} 
      $backgroundColor={'#ffffff'}
      $hasNavHeader={isPrivate}
      style={{ padding: '0' }}
    >
      <MainContent $isMobileView={isMobileView} style={{ width: '100%', maxWidth: '100%' }}>
        <div style={{ padding: '0px' }}>
          <Section style={{ padding: '0px' }}>
            <ImplementationCalendarPage />
          </Section>
        </div>
        <SectionDivider />
        <Footer />
      </MainContent>
    </Main>
    </>
  )
}
